import { render, staticRenderFns } from "./LeadCenterContacts.vue?vue&type=template&id=412d53a3&"
import script from "./LeadCenterContacts.vue?vue&type=script&lang=js&"
export * from "./LeadCenterContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports